module.exports = __webpack_public_path__ + "img/itp.b50ccbbc.png";